export var NamingServiceName;
(function (NamingServiceName) {
    NamingServiceName["DAS"] = "DAS";
})(NamingServiceName || (NamingServiceName = {}));
export var CoinType;
(function (CoinType) {
    CoinType["ETH"] = "60";
    CoinType["TRX"] = "195";
    CoinType["BNB"] = "714";
    CoinType["MATIC"] = "966";
})(CoinType || (CoinType = {}));
export var ChainId;
(function (ChainId) {
    ChainId["ETH"] = "1";
    ChainId["BSC"] = "56";
    ChainId["Polygon"] = "137";
})(ChainId || (ChainId = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHVibGljVHlwZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi9zcmMvdHlwZXMvcHVibGljVHlwZXMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBa0JBLE1BQU0sQ0FBTixJQUFZLGlCQUVYO0FBRkQsV0FBWSxpQkFBaUI7SUFDM0IsZ0NBQVcsQ0FBQTtBQUNiLENBQUMsRUFGVyxpQkFBaUIsS0FBakIsaUJBQWlCLFFBRTVCO0FBeUJELE1BQU0sQ0FBTixJQUFZLFFBS1g7QUFMRCxXQUFZLFFBQVE7SUFDbEIsc0JBQVUsQ0FBQTtJQUNWLHVCQUFXLENBQUE7SUFDWCx1QkFBVyxDQUFBO0lBQ1gseUJBQWEsQ0FBQTtBQUNmLENBQUMsRUFMVyxRQUFRLEtBQVIsUUFBUSxRQUtuQjtBQUVELE1BQU0sQ0FBTixJQUFZLE9BSVg7QUFKRCxXQUFZLE9BQU87SUFDakIsb0JBQVMsQ0FBQTtJQUNULHFCQUFVLENBQUE7SUFDViwwQkFBZSxDQUFBO0FBQ2pCLENBQUMsRUFKVyxPQUFPLEtBQVAsT0FBTyxRQUlsQiJ9